import { Breadcrumb, Layout, Spin, Form, Input, Button, Row, Col, Card, Switch, message, Select, InputNumber } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Headerdiv from '../layout/header';
import Footerdiv from '../layout/footer';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import axiosClient from '../../api/axiosClient';
import { APPBACKGROUND_COLOR } from '../appsettings';

const { TextArea } = Input;

const AddSalesItem = () => {
    const [form] = Form.useForm();
    const USERID = localStorage.getItem("USERID");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = async (values) => {
        setLoading(true);
        const payload = {
            sp_code: values.sp_code,
            sp_title: values.sp_title,
            sp_desc: values.sp_desc || '',
            sp_type: values.sp_type,
            sp_duration: values.sp_duration,
            sp_uprice: values.sp_uprice || 0,
            sp_active: values.sp_active ? true : false,
            by: USERID
        };

        try {
            const response = await axiosClient.post('/sales/add_sales_item.php', payload);
            const data = response.data;

            if (data.status === "success") {
                message.success(data.message);
                form.resetFields();
                navigate('/sales/items');
            } else {
                message.error(data.message || "Failed to add sales item.");
            }
        } catch (error) {
            console.error("API Error:", error);
            message.error(error.response?.data?.message || "Failed to connect to server.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading} tip="Saving Sales Item...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR, minHeight: '100vh' }}>
                <Headerdiv />
                <Content style={{ padding: "10px" }}>
                    <Breadcrumb style={{ marginBottom: 10 }}>
                        <Breadcrumb.Item><Link to={"/sales/items"}>Sales</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>Add Sales Item</Breadcrumb.Item>
                    </Breadcrumb>

                    <Form layout="vertical" form={form} onFinish={onFinish}>
                        <Card title="Sales Item Information">
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="sp_code"
                                        label="Code"
                                        rules={[
                                            { required: true, message: "Code is required" },
                                            { max: 5, message: "Code cannot exceed 5 characters" }
                                        ]}
                                    >
                                        <Input placeholder="Enter Code (max 5 chars)" maxLength={5} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="sp_title"
                                        label="Title"
                                        rules={[
                                            { required: true, message: "Title is required" },
                                            { max: 200, message: "Title cannot exceed 200 characters" }
                                        ]}
                                    >
                                        <Input placeholder="Enter Title" maxLength={200} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="sp_type"
                                        label="Type"
                                        rules={[{ required: true, message: "Type is required" }]}
                                    >
                                        <Select placeholder="Select Type">
                                            <Select.Option value="ITEM">Item</Select.Option>
                                            <Select.Option value="PACKAGE">Package</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="sp_duration"
                                        label="Duration"
                                        rules={[{ required: true, message: "Duration is required" }]}
                                    >
                                        <Select placeholder="Select Duration">
                                            <Select.Option value="ONETIME">One Time</Select.Option>
                                            <Select.Option value="DAILY">Daily</Select.Option>
                                            <Select.Option value="MONTHLY">Monthly</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="sp_uprice"
                                        label="Price (Rs.)"
                                        rules={[{ required: true, message: "Price is required" }]}
                                    >
                                        <InputNumber 
                                            style={{ width: '100%' }}
                                            placeholder="Enter Price" 
                                            min={0}
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/,/g, '')}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item name="sp_active" label="Status" valuePropName="checked" initialValue={true}>
                                        <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Form.Item 
                                        name="sp_desc" 
                                        label="Description"
                                        rules={[{ max: 1500, message: "Description cannot exceed 1500 characters" }]}
                                    >
                                        <TextArea rows={4} placeholder="Enter Description" maxLength={1500} showCount />
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Row justify="end" gutter={[10, 10]} style={{ marginTop: 10 }}>
                                        <Col>
                                            <Button onClick={() => form.resetFields()}>Clear</Button>
                                        </Col>
                                        <Col>
                                            <Button type="primary" htmlType="submit">
                                                Save Sales Item
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card>
                    </Form>
                </Content>
                <Footerdiv />
            </Layout>
        </Spin>
    );
};

export default AddSalesItem;
